// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2QHGD","clinicsSelect":"TableHeading_clinicsSelect__P4g_t"};